import { TRootState } from '@/store/store';

export const isInfoModalVisible = ({ referrals }: TRootState) => referrals.isInfoModalVisible;
